/**
 * Animation components barrel export.
 *
 * All player rendering now uses SVG-based block architecture:
 * - AnimatedPlayersOverlay for current positions
 * - GhostPlayersOverlay for ghost trail at start positions
 */

// SVG-based player rendering (unified block architecture)
export { AnimatedPlayersOverlay } from './AnimatedPlayersOverlay'
export { GhostPlayersOverlay } from './GhostPlayersOverlay'

// Core animation components
export { AnimationCanvas } from './AnimationCanvas'
export { AnimationCanvasRenderer } from './AnimationCanvasRenderer'
export { AnimationControls } from './AnimationControls'
export { AnimationControlBar } from './AnimationControlBar'
export { InPlaceAnimationOverlay } from './InPlaceAnimationOverlay'
export { PlayViewerModal } from './PlayViewerModal'
